<template>
  <div>
    <HeadInfo title="电视剧" />
    <Episode />
    <Epitasis />
    <Relative />
    <Actors />
    <Like />
    <Gotop />
    <Rec />
    <Ob />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Gotop from '../common/components/Gotop.vue';
import pageExpose from '../common/mixins/pageExpose';
import Actors from './components/Actors.vue';
import Episode from './components/Episode.vue';
import Epitasis from './components/Epitasis.vue';
import HeadInfo from './components/HeadInfo.vue';
import Like from './components/Like.vue';
import Ob from './components/ObserveModule.vue';
import Rec from './components/Rec.vue';
import Relative from './components/Relative.vue';

export default {
  components: {
    HeadInfo,
    Episode,
    Epitasis,
    Relative,
    Actors,
    Like,
    Gotop,
    Rec,
    Ob,
  },
  mixins: [pageExpose],
  computed: {
    ...mapState('detail', ['itemData']),
  },
  asyncData({ context, store, route }) {
    return store
      .dispatch('detail/prefetchData', { context, route })
      .catch(err => console.log('[DETAIL_TELEPLAY_PREFETCH_ERROR]', err));
  },
};
</script>
